module.exports = __webpack_public_path__ + "img/sn.e875d4ee.svg";